import { usePageTitle } from '../../utils/hooks';

export function useHaicPageTitle(pageTitle: string, haicName?: string) {
  const title = `${pageTitle} | ${haicName || 'H2O AI Cloud'}`;
  usePageTitle(title);
}
